import routesSystem from '/@/router/routes/system'
import routesSet from '/@/router/routes/set'
import routesData from '/@/router/routes/data'
import routesMaterial from '/@/router/routes/material'
import { pcMain, pcOpen } from '/@/router/routes/plugins/pc'
import { formMain, formOpen } from '/@/router/routes/plugins/form'
import { appMain, appOpen } from '/@/router/routes/plugins/app'
import { searchMain } from '/@/router/routes/plugins/search'
import { docMain, docEdit } from '/@/router/routes/plugins/doc'
import businessMain from '/@/router/routes/plugins/business'
import { siteMain } from '/@/router/routes/plugins/site'
import whiteList from '/@/router/routes/whiteList'
import { certificateMain } from '/@/router/routes/plugins/certificate'
import { collectorMain } from '/@/router/routes/plugins/collector'
import { chartMain } from '/@/router/routes/plugins/chart'
import routesMember from '/@/router/routes/member'
import { ticketMain } from '/@/router/routes/plugins/ticket'
import { seoMain } from '/@/router/routes/plugins/seo'
import { translateMain } from '/@/router/routes/plugins/translate'
import traffic from '/@/router/routes/traffic'
import { aiWriterMain } from '/@/router/routes/plugins/aiWriter'
import { workHandoverMain } from '/@/router/routes/plugins/workHandover'
import { siteCopyMain } from '/@/router/routes/plugins/site_copy'

const mainRoutes = {
  name: 'layout',
  path: '/',
  redirect: '/home',
  meta: {
    title: '首页',
    name: '首页'
  },
  component: () => import('/@/layout/index.vue'),
  children: [
    {
      name: 'home',
      path: '/home',
      icon: 'home-filled',
      meta: {
        title: '首页',
        name: '首页'
      },
      component: () => import('/@/views/Index.vue')
    },
    ...routesSystem,
    ...routesSet,
    ...pcMain,
    ...routesData,
    ...routesMaterial,
    ...formMain,
    ...appMain,
    ...searchMain,
    ...docMain,
    ...businessMain,
    ...siteMain,
    ...certificateMain,
    ...collectorMain,
    ...chartMain,
    ...routesMember,
    ...ticketMain,
    ...seoMain,
    ...translateMain,
    ...traffic,
    ...aiWriterMain,
    ...workHandoverMain,
    ...siteCopyMain
  ]
}
// 后台菜单
const routesMap = {}
mainRoutes.children.forEach(item => {
  if (item.meta) {
    item.meta.needLogin = true
  }
  routesMap[item.path] = item
})
const routes = [
  mainRoutes,
  ...pcOpen,
  ...formOpen,
  ...appOpen,
  ...docEdit,
  ...whiteList
]
export { routesMap, routes }
